module.exports = __webpack_public_path__ + "img/marketplace-big.01f345e8.png";